// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"58ef1220","140":"06064070","173":"422f785e","231":"c3d78ef5","259":"861056f8","269":"80f27d9a","474":"451a7d3e","548":"50f1a24d","599":"2370f5b0","728":"fa0af417","987":"2285a559"}[chunkId] + ".chunk.js";
};